(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// Cart Scripts
// These apply to both the cart page and the flyout cart on every other page

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Flyout Cart
  const flyoutCart = document.querySelector('.js-flyout-cart');
  const flyoutCartToggles = document.querySelectorAll('.js-toggle-flyout-cart');
  flyoutCart.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));

  // --- ADDED: Function to refresh Shop Pay Installments banner ---
  const refreshPaymentTerms = async () => {
    try {
      // Detect current context
      const flyoutCart = document.querySelector('.js-flyout-cart');
      const cartPageForm = document.querySelector('form[action="/cart"]:not(.js-flyout-cart-form)');

      // Determine which section to request
      let sectionId = '';
      if (flyoutCart) sectionId = 'flyout-cart';else if (cartPageForm) sectionId = 'main-cart'; // or whatever your main cart section ID is

      if (!sectionId) return; // no cart context found

      // Fetch section HTML from Shopify
      const response = await fetch(window.location.pathname + `?section_id=${sectionId}`);
      const html = await response.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Find new payment terms snippet
      const newTerms = tempDiv.querySelector('[data-payment-terms]');
      const currentTerms = document.querySelector('[data-payment-terms]');
      if (newTerms && currentTerms) {
        currentTerms.innerHTML = newTerms.innerHTML;
      }
    } catch (err) {
      console.error('Error refreshing payment terms:', err);
    }
  };
  // --- END ADDED ---

  // Main Update Function
  // Runs whenever a product in the cart is changed (added, removed, quantity changed)
  const updateFlyoutCart = () => {
    // Get updated cart data
    fetch('/cart.js').then(response => response.json()).then(async data => {
      // Update all cart total count badges
      document.querySelectorAll('.js-cart-count').forEach(badge => badge.textContent = data.item_count);

      // Update free shipping progress bar
      const freeShippingProgressBar = document.querySelector('.js-free-shipping-progress-bar');
      if (freeShippingProgressBar) {
        const freeShippingThreshold = freeShippingProgressBar.dataset.freeShippingThreshold;
        const freeShippingDifference = freeShippingThreshold - data.total_price;
        // Upate bar style based on progress
        const freeShippingProgress = Math.min(data.total_price / freeShippingThreshold, 1);
        freeShippingProgressBar.style.width = `${freeShippingProgress * 100}%`;
        // Update text based on progress
        const freeShippingProgressText = document.querySelector('.js-free-shipping-text');
        if (freeShippingDifference > 0) {
          freeShippingProgressText.textContent = `You're $${freeShippingDifference / 100} away from `;
        } else {
          freeShippingProgressText.textContent = "You've unlocked ";
        }
      }

      // Rebuild cart product list
      const cartProductsList = document.querySelector('.js-cart-item-list');
      let cartItemsHTML = '<li>No items here yet!</li>';
      if (data.items.length > 0) {
        // Group items by Gift Box property
        const giftBoxGroups = {};
        const nonGiftBoxItems = [];
        data.items.forEach(item => {
          if (item.properties && item.properties['Gift Box']) {
            const boxLabel = item.properties['Gift Box'];
            if (!giftBoxGroups[boxLabel]) giftBoxGroups[boxLabel] = [];
            giftBoxGroups[boxLabel].push(item);
          } else {
            nonGiftBoxItems.push(item);
          }
        });
        cartItemsHTML = '';
        // Render gift box groups
        Object.keys(giftBoxGroups).sort((a, b) => {
          // Sort by box number if possible
          const numA = parseInt(a.replace(/[^\d]/g, ''));
          const numB = parseInt(b.replace(/[^\d]/g, ''));
          return numA - numB;
        }).forEach(boxLabel => {
          cartItemsHTML += `<li class="flyout-cart__giftbox-group"><h4 class="flyout-cart__giftbox-heading">${boxLabel.replace(/(#\d+)/, '<span class="sr-only">#1</span>')}</h4><ul class="flyout-cart__giftbox-list">`;
          cartItemsHTML += giftBoxGroups[boxLabel].map(item => cartProductTemplate(item)).join('');
          cartItemsHTML += '</ul></li>';
        });
        // Render non-gift box items
        if (nonGiftBoxItems.length > 0) {
          cartItemsHTML += nonGiftBoxItems.map(item => cartProductTemplate(item)).join('');
        }
      }
      cartProductsList.textContent = '';
      cartProductsList.insertAdjacentHTML('beforeend', cartItemsHTML);
      addEventListenersForCartItems();

      // Update checkout button based on rules
      let isValidCart = true;
      const cartAction = document.querySelector('.js-cart-action');
      const productData = await hydrateProductData(data.items);

      // Check if any items in the cart
      if (data.items.length == 0) {
        isValidCart = false;
        cartAction.textContent = '';
        cartAction.insertAdjacentHTML('beforeend', `<div class="flyout-cart__subtotal"><span class="flyout-cart__subtotal-text">Cart Subtotal</span> <span class="flyout-cart__subtotal-num">${formatPrice(data.items_subtotal_price)}</span></div>
                    <div class="flyout-cart__checkout disabled">
                    <p class="flyout-cart__action-text">Nothing here yet!</p>
                    </div>`);
      }

      // Check if an item must be ordered alone
      let mustOrderAloneProduct = null;
      productData.forEach(product => {
        if (product.product.tags.includes('must-order-alone')) {
          mustOrderAloneProduct = product;
        }
      });
      if (mustOrderAloneProduct && data.items.length > 1) {
        isValidCart = false;
        cartAction.textContent = '';
        cartAction.insertAdjacentHTML('beforeend', `<div class="flyout-cart__subtotal"><span class="flyout-cart__subtotal-text">Cart Subtotal</span> <span class="flyout-cart__subtotal-num">${formatPrice(data.items_subtotal_price)}</span></div>
                    <div class="flyout-cart__checkout disabled">
                    <p class="flyout-cart__action-text">"${product.title}" is a special event and can only be ordered alone. Please remove any other products from your cart to continue.</p>
                    </div>`);
      }

      // Update checkout button based on validity
      if (isValidCart) {
        cartAction.textContent = '';
        cartAction.insertAdjacentHTML('beforeend', `<button data-cart-checkout class="btn btn--secondary flyout-cart__checkout" ${data.items.length > 0 ? '' : 'disabled'}" type="submit" name="checkout">
                    Checkout - <span class="js-cart-subtotal">${formatPrice(data.items_subtotal_price)}</span>
                    </button>`);
      }

      // Update recommendations section if at least one product in the cart
      if (data.items.length > 0) {
        let productRecommendationsList = await getProductRecommendations(data);
        const cartProductIDs = data.items.map(item => item.product_id);

        // Remove any recommendations that are already in the cart or have vendor 'Box Builder'
        productRecommendationsList = productRecommendationsList.filter(recommendation => !cartProductIDs.includes(recommendation.id) && recommendation.vendor !== 'Box Builder' && recommendation.title !== 'Insulated Shipping Fee' &&
        // Exclude by title
        !(recommendation.tags && (recommendation.tags.includes('DYO Packaging') || recommendation.tags.includes('DYO Message') || recommendation.title == 'Insulated Shipping Fee' // Exclude by tag
        ) || recommendation.product_type && (recommendation.product_type.toLowerCase().includes('dyo packaging') || recommendation.product_type.toLowerCase().includes('dyo message'))));

        // Remove any duplicate recommendations
        const uniqueRecommendations = [];
        productRecommendationsList.forEach(recommendation => {
          if (!uniqueRecommendations.some(item => item.id === recommendation.id)) {
            uniqueRecommendations.push(recommendation);
          }
        });
        productRecommendationsList = uniqueRecommendations;

        // Randomize the array and limit to 4 items
        productRecommendationsList.sort(() => Math.random() - 0.5);
        productRecommendationsList.length = Math.min(productRecommendationsList.length, 2);

        // Add recommendations to the list and apply event listeners
        const recommendationsList = document.querySelector('.js-recommendations-list');
        recommendationsList.textContent = '';
        const lastIndex = productRecommendationsList.length - 1;
        const recommendationsHTML = productRecommendationsList.map((item, index) => cartRecommendationTemplate(item, index, lastIndex)).join('');
        recommendationsList.insertAdjacentHTML('beforeend', recommendationsHTML);
        const recommendationsTitle = document.querySelector('.flyout-cart__recommendations-title');
        if (recommendationsTitle) {
          if (productRecommendationsList.length === 0) {
            recommendationsTitle.style.display = 'none';
          } else {
            recommendationsTitle.style.display = '';
          }
        }
        // If only one recommendation, make it a single item carousel
        if (productRecommendationsList.length == 1) {
          recommendationsList.parentElement.classList.add('carousel__single');
        }
        addEventListenersForRecommendations();
      }

      // --- ADDED: refresh Shop Pay Installments banner dynamically ---
      refreshPaymentTerms();
      // --- END ADDED ---
    }).catch(error => console.log(error));
  };

  // Fetch product data for each item in the cart
  async function hydrateProductData(lineItems) {
    const productData = await Promise.all(lineItems.map(async item => {
      const response = await fetch(`/products/${item.handle}.js`);
      const product = await response.json();
      return {
        product: {
          ...product
        },
        lineItem: {
          ...item
        }
      }; //include line item info for quantity details
    }));
    return productData;
  }

  // Helper to format price without trailing .00
  function formatPrice(price) {
    var val = price / 100;
    return val % 1 === 0 ? '$' + val.toFixed(0) : '$' + val.toFixed(2);
  }

  // Build HTML for each product in the cart
  const cartProductTemplate = item => {
    // PATCH: Hide qty controls for DYO packaging or card items
    const isDyoPackaging = item.properties && item.properties['DYO Packaging'] === 'true';
    const isDyoCard = item.properties && (item.properties['Card To'] !== undefined || item.properties['Card Message'] !== undefined);
    return `
        <li class="flyout-cart__product">
            <div class="flyout-cart__product-main">
              ${item.vendor != 'Box Builder' ? `<a class="flyout-cart__product-image-wrap" href="${item.url}">` : `<div class="flyout-cart__product-image-wrap">`}
              <img src="${item.featured_image.url}" alt="${item.featured_image.alt}" width="200" height="200" class="flyout-cart__product-image">
              ${item.vendor != 'Box Builder' ? `</a>` : `</div>`}
              <div>
                <p class="flyout-cart__product-vendor">${item.vendor}</p>
                ${item.vendor != 'Box Builder' ? `<a href="${item.url}" class="flyout-cart__product-title">${item.title}</a>` : `<div class="flyout-cart__product-title">${item.title}</div>`}
                ${item.variant_title && item.variant_title != 'Default Title' ? `<p class="flyout-cart__product-subtitle">${item.variant_title}</p>` : ''}
                ${item.selling_plan_allocation ? `<p class="flyout-cart__product-subtitle subscription">(${item.selling_plan_allocation.selling_plan.name})</p>` : ''}
                ${item.sku ? `<p class="flyout-cart__product-subtitle">SKU: ${item.sku}</p>` : ''}
                <!-- Show line item properties for DYO -->
${item.properties && Object.keys(item.properties).length > 0 ? `<div class="flyout-cart__product-properties">${Object.keys(item.properties).filter(key => key !== 'Gift Box').map(key => `<div class="flyout-cart__product-property"><strong>${key}:</strong> ${item.properties[key]}</div>`).join('')}</div>` : ''}              </div>
            </div>
            ${!isDyoPackaging && !isDyoCard ? `
            <div class="flyout-cart__product-qty">
              <button type="button" class="flyout-cart__product-qty-btn js-qty-decrease">-</button>
              <input type="number" class="flyout-cart__product-qty-input js-qty-input" name="updates[]" value="${item.quantity}" data-line-item-id="${item.id}" min="0" aria-label="Quantity">
              <button type="button" class="flyout-cart__product-qty-btn js-qty-increase">+</button>
            </div>
            ` : ''}
            <button type="button" class="flyout-cart__product-delete js-remove-product" data-line-item-id="${item.id}">
              <span class="sr-only">Remove '${item.title}' from your cart</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.251 15.251">
                <g fill="none" stroke-linecap="round" stroke-width="1">
                <path d="M13.13 2.121L2.12176163 13.12923837M2.121 2.121l11.00823837 11.00823837"></path>
                </g>
              </svg>
            </button>
            <p class="flyout-cart__product-price">
                ${item.final_line_price < item.original_line_price ? '<s>' + formatPrice(item.original_line_price) + '</s>' : ''}
                ${formatPrice(item.final_line_price)}
            </p>
        </li>
        `;
  };

  // Get product recommendations
  const getProductRecommendations = async data => {
    const productRecommendationsURLs = data.items.map(item => `/recommendations/products.json?product_id=${item.product_id}&limit=2`);
    const productRecommendationsContainer = document.querySelector('.js-recommendations-list');
    const recommendationsData = await Promise.all(productRecommendationsURLs.map(async url => {
      const response = await fetch(url);
      const data = await response.json();
      return data;
    }));
    const productRecommendationsList = [];
    recommendationsData.forEach(recommendations => {
      productRecommendationsList.push(...recommendations.products);
    });
    return productRecommendationsList;
  };

  // Build HTML for cart recommendation items
  const cartRecommendationTemplate = (item, index, lastIndex) => {
    let variantSelect = '';
    if (item.variants.length > 1) {
      variantSelect = `
            <select name="id" class="flyout-cart__recommendations-select js-recommendations-select">
                ${item.variants.map(variant => {
        return `<option value="${variant.id}">${variant.title}</option>`;
      }).join('')}
            </select>`;
    } else {
      variantSelect = `<input class="js-recommendations-select" type="hidden" name="id" value="${item.variants[0].id}">`;
    }
    return `
        <li class="flyout-cart__recommendations-item js-product-recommendation-wrap carousel__slide ${index == lastIndex ? 'carousel__single' : ''}" id="carousel__slide${index}"
              tabindex="0" data-product-sku="${item.variants[0].sku}" data-product-title="${item.title}" data-product-price="${item.price / 100}">
            <div class="carousel__snapper">
                <div class="flyout-cart__recommendations-item-wrap">
                    <div class="flyout-cart__recommendations-item-content">
                        <a class="flyout-cart__recommendations-image-wrap" href="${item.url}">
                            <img src="${item.media[0].src}" alt="${item.media[0].alt}" width="200" height="200" class="flyout-cart__recommendations-image">
                        </a>
                        <div>
                            <a href="${item.url}" class="flyout-cart__recommendations-item-title">${item.title}</a>
                            <p class="flyout-cart__recommendations-price">
                                ${formatPrice(item.price)}
                            </p>
                        </div>
                    </div>
                    <div class="flyout-cart__recommendations-form">
                        ${variantSelect}
                        <button type="button" class="flyout-cart__recommendations-add btn js-recommendation-add-to-cart">
                            Add to Bag
                        </button>
                    </div>
                    <a href="#carousel__slide${index == 0 ? lastIndex : index - 1}"
                        class="carousel__prev js-carousel-button" data-upcoming-slide="${index == 0 ? lastIndex : index - 1}"><span class="sr-only">Go to previous slide</span></a>
                    <a href="#carousel__slide${index == lastIndex ? 0 : index + 1}"
                        class="carousel__next js-carousel-button" data-upcoming-slide="${index == lastIndex ? 0 : index + 1}"><span class="sr-only">Go to next slide</span></a>
                </div>
            </div>
        </li>
        `;
  };

  // Add event listeners to cart recommendation items

  const addEventListenersForRecommendations = () => {
    document.querySelectorAll('.js-recommendation-add-to-cart').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();

        // Add 10% discount code if enabled by section settings
        const discountEnabled = document.querySelector('.js-flyout-cart-form').dataset.recommendationDiscountEnabled;
        const recommendationsDiscountCode = document.querySelector('.js-flyout-cart-form').dataset.recommendationsDiscountCode;
        if (discountEnabled) {
          fetch(`/discount/${recommendationsDiscountCode}`);
        }

        // Add product to cart
        const variantID = button.closest('.js-product-recommendation-wrap').querySelector('.js-recommendations-select').value;
        const data = {
          id: variantID,
          quantity: 1
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then(response => response.json()).then(data => {
          // track the addition
          sendCustomRecommendationAddToCartEvent(data);
          // rerun update function to update cart
          updateFlyoutCart();
        });
      });
    });

    // Add event listeners for carousel buttons
    document.querySelectorAll('.js-carousel-button').forEach(button => {
      button.addEventListener('click', event => {
        const upcomingSlide = button.dataset.upcomingSlide;
        sendCustomRecommendationViewEvent(upcomingSlide);
      });
    });
  };

  // Function to open or close flyout cart
  // Used whenever user clicks on cart icon or adds an item to cart
  const toggleCart = (toggle, event) => {
    event.preventDefault();

    // Close cart when user clicks outside of it
    const closeFlyoutOnOutsideClick = event => {
      if (!flyoutCart.contains(event.target) && !toggle.contains(event.target)) {
        event.preventDefault(); // Don't click into any underlying elements
        flyoutCart.classList.remove('is-open');
        document.removeEventListener('click', closeFlyoutOnOutsideClick);
      }
    };
    if (flyoutCart.classList.contains('is-open')) {
      // We are closing the cart flyout
      flyoutCart.classList.remove('is-open');
      // document.removeEventListener('click', closeFlyoutOnOutsideClick);
    } else {
      // We are opening the cart flyout
      flyoutCart.classList.add('is-open');
      // document.addEventListener('click', closeFlyoutOnOutsideClick);
      sendCustomRecommendationViewEvent(0);
    }
  };
  // Event listener for all flyout cart toggle buttons
  flyoutCartToggles.forEach(toggle => toggle.addEventListener('click', event => toggleCart(toggle, event)));

  // Functions to handle adjusting quantity of items in flyout cart
  const increaseQuantity = event => {
    const input = event.target.parentElement.querySelector('input');
    input.value = parseInt(input.value) + 1;
    input.dispatchEvent(new Event('change'));
  };
  const decreaseQuantity = event => {
    const input = event.target.parentElement.querySelector('input');
    if (parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
      input.dispatchEvent(new Event('change'));
    }
  };
  const addEventListenersForCartItems = () => {
    // Event listeners for all quantity buttons in flyout cart
    document.querySelectorAll('.js-qty-increase').forEach(button => button.addEventListener('click', event => increaseQuantity(event)));
    document.querySelectorAll('.js-qty-decrease').forEach(button => button.addEventListener('click', event => decreaseQuantity(event)));

    // On change listener for quantity input to adjust cart line item quantity
    document.querySelectorAll('.js-qty-input').forEach(input => {
      input.addEventListener('change', event => {
        const lineItemId = input.dataset.lineItemId;
        const quantity = parseInt(input.value);
        const data = {
          id: lineItemId,
          quantity: quantity
        };
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then(response => response.json()).then(data => {
          updateFlyoutCart(data.item_count);
        }).catch(error => console.log(error));
      });
    });

    // Event listener for removing items from cart
    document.querySelectorAll('.js-remove-product').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        const lineItemId = button.dataset.lineItemId;
        const data = {
          id: lineItemId,
          quantity: 0
        };
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then(response => response.json()).then(data => {
          updateFlyoutCart();
          // PATCH: Notify DYO UI to refresh built boxes
          if (document.querySelector('.dyo-giftbox__built-boxes')) {
            window.dispatchEvent(new CustomEvent('dyo:cart-updated'));
          }
        }).catch(error => console.log(error));
      });
    });
  };
  const addEventListenersForAddToCartBtns = () => {
    document.querySelectorAll('.js-product-form').forEach(form => {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const data = new URLSearchParams(new FormData(form));
        fetch('/cart/add.js', {
          method: 'POST',
          body: data
        }).then(response => response.json()).then(() => {
          // Wait for the cart to actually update before fetching recommendations
          setTimeout(() => {
            flyoutCart.classList.add('is-open');
            sendCustomRecommendationViewEvent(0);
            updateFlyoutCart();
          }, 250); // 250ms delay to allow Shopify to update the cart
        }).catch(error => console.log(error));
      });
    });
  };

  // Initialize cart on page load
  addEventListenersForAddToCartBtns();
  updateFlyoutCart();
  window.addEventListener('dyo:cart-updated', updateFlyoutCart);
});
const sendCustomRecommendationViewEvent = index => {
  const currentSlide = document.getElementById(`carousel__slide${index}`);
  if (currentSlide && typeof gtag === 'function') {
    gtag('event', 'view_upsell_item', {
      'value': currentSlide.dataset.productPrice,
      'items': [{
        'id': currentSlide.dataset.productSku,
        'name': currentSlide.dataset.productTitle,
        'price': currentSlide.dataset.productPrice
      }]
    });
  }
};
const sendCustomRecommendationAddToCartEvent = product => {
  if (product && typeof gtag === 'function') {
    gtag('event', 'add_upsell_item', {
      'value': product.price / 100,
      'items': [{
        'id': product.sku,
        'name': product.title,
        'price': product.price / 100
      }]
    });
  }
};
},{}]},{},[1]);
